import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { usePostHog } from 'posthog-js/react'

export const PostHogPageView = () => {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (posthog && !window.Cypress && !window.Playwright) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, posthog])

  return null
}
